import { render, staticRenderFns } from "./book-account.vue?vue&type=template&id=a85d1b42&scoped=true&"
import script from "./book-account.vue?vue&type=script&lang=js&"
export * from "./book-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85d1b42",
  null
  
)

export default component.exports